export default "__VITE_ASSET__iqCAJT0y__"